import React from "react";

/**
 * Official brand logo — never redesigned, never regenerated.
 * Renders the uploaded PNG asset. Two variants:
 *  - "full"     : TF mark + THE FABRICS + Wear Your Identity tagline
 *  - "monogram" : just the TF letter mark (favicons, tight badges)
 *
 * Use `invert` on dark backgrounds to switch black artwork to white
 * via CSS filter (does not modify the source file).
 */
export default function Logo({
  variant = "full",
  className = "",
  invert = false,
  loading = "lazy",
  ...rest
}) {
  const src = variant === "monogram" ? "/brand/logo-monogram.png" : "/brand/logo-full.png";
  const alt = variant === "monogram" ? "TF — The Fabrics" : "THE FABRICS · Wear Your Identity.";
  const style = invert ? { filter: "invert(1) brightness(1.05)" } : undefined;
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      draggable="false"
      style={style}
      className={`select-none ${className}`}
      data-testid={`brand-logo-${variant}`}
      {...rest}
    />
  );
}
